import api from '@/services/utils/apiInstance'

export class RepairCenterService {
  async getRepairCenterListForUserStores() {
    const response = await api.get('/distributor/repair-center/list')
    return response.data
  }

  async getRepairCenterDetailByRepairFile(repairFileId) {
    const response = await api.get('/distributor/repair-center/' + repairFileId)
    return response.data
  }
}

export default new RepairCenterService()
